export const INTEGRATION_API_BASE = process.env.INTEGRATIONS_API;
export const XERO_INTEGRATION_API_BASE = process.env.XERO_INTEGRATIONS_API;
export const XERO_INTEGRATION_API_PATH = 'clients';
export const XERO_INTEGRATION_CONNECTION_PATH = 'connection';
export const XERO_INTEGRATION_ORGANISATIONS_PATH = 'organisations';
export const XERO_INTEGRATION_XERO_ACCOUNT_CODE_MAPPINGS_PATH =
  'account-code-mappings';
export const XERO_INTEGRATION_XERO_ACCOUNTS_PATH = 'xero-accounts';

export const XERO_CONNECT_PATH = (clientId: string) =>
  `${XERO_INTEGRATION_API_BASE}/${XERO_INTEGRATION_API_PATH}/${encodeURIComponent(
    clientId,
  )}/oauth2-url`;
